<template>
  <Layout>
    <Title
      title="Objetos"
      hasPrint
      :hasNewRegister="true"
      :routeNewRegister="handleNavigationRegister"
    />
    <Table
      :key="tableKey"
      :tableData="tableData"
      :items="summaryOsObjects"
      :pagination="true"
      :perPage="paginationOsObjects.perPage"
      :startItem="paginationOsObjects.startItem"
      :endItem="paginationOsObjects.endItem"
      :totalItems="paginationOsObjects.totalItems"
      :page="paginationOsObjects.currentPage"
      :onClickRow="handleRowClick"
      @changeItemsPerPage="changeItemsPerPage"
      @changePage="changePage"
    />
  </Layout>
</template>

<script>
import { Layout, Title, Table, TableData, Actions } from '@/components';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ServiceOrderObjects',
  components: {
    Layout,
    Title,
    Table,
  },
  async mounted() {
    await this.resetOsObjectsState();

    try {
      this.setLoading(true);
      await this.setSummaryOsObjects({
        pagination: this.paginationOsObjects,
      });
    } finally {
      this.setLoading(false);
    }
  },
  computed: {
    ...mapState('osObjects', [
      'summaryOsObjects',
      'paginationOsObjects',
      'tableKey',
    ]),

    tableData() {
      const { Data, TABLE_CELL_CUSTOM, TABLE_CELL_ALIGN } = TableData;
      const DataTable = new Data({
        panelActions: true,
        panelActionsSearch: true,
        select: true,
        titleMobile: (item) => item.description,
        onSearch: this.search,
      });

      DataTable.addField({
        key: 'description',
        label: 'Descrição',
        sortable: true,
        width: 1000,
        align: TABLE_CELL_ALIGN.left,
      })
        .addField({
          key: TABLE_CELL_CUSTOM.status,
          label: 'Status',
          align: TABLE_CELL_ALIGN.center,
          formatter: (value, field, items) => ({
            value: items.active ? 'Ativo' : 'Inativo',
            color: items.active ? 'success' : 'danger',
          }),
        })
        .addActions(
          Actions('delete', (selected) => {
            const idsToDelete = selected.map((e) => e.id);

            this.confirm({
              message: 'Tem certeza que deseja excluir?',
              type: 2,
              onOk: async () => {
                try {
                  this.setLoading(true);

                  const { ids, warnings } = await this.deleteOsObjects(
                    idsToDelete,
                  );

                  await this.setSummaryOsObjects({
                    pagination: this.paginationOsObjects,
                  });

                  if (ids.length) {
                    this.$alert.success('Registros excluídos com sucesso!');
                  }
                  if (warnings.length) {
                    warnings.forEach((i) => {
                      this.$alert.warning(i);
                    });
                  }
                } finally {
                  this.setLoading(false);
                }
              },
            });
          }),
        );
      return DataTable;
    },
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    ...mapActions('osObjects', [
      'resetOsObjectsState',
      'setSummaryOsObjects',
      'deleteOsObjects',
    ]),

    handleRowClick(item) {
      this.$router.push({
        name: 'ServiceOrderObjectsEdit',
        params: { id: item.id },
      });
    },
    async handleNavigationRegister() {
      return this.$router.push({ name: 'ServiceOrderObjectsRegister' });
    },
    async search(value) {
      this.setLoading(true);

      await this.setSummaryOsObjects({
        search: value,
        pagination: { ...this.paginationOsObjects, currentPage: 1 },
      });
      this.setLoading(false);
    },
    async changeItemsPerPage(items) {
      const pagination = {
        ...this.paginationOsObjects,
        perPage: items,
        currentPage: 1,
      };
      this.setLoading(true);
      await this.setSummaryOsObjects({ pagination });
      this.setLoading(false);
    },
    async changePage(page) {
      const pagination = {
        ...this.paginationOsObjects,
        currentPage: page,
      };
      this.setLoading(true);
      await this.setSummaryOsObjects({ pagination });
      this.setLoading(false);
    },
  },
};
</script>
